<template>
  <div>
    <v-row justify-md="center" class="mb-10">
      <v-col sm="10" md="5" class="landing_texts mt-5 ml-10" v-if="divisionTheme != 'trt'">

        <div v-if="blurbs.length">
          <h2 class="landing_texts-title" v-html="blurbs[1].header"></h2>
          <br/>
          <p class="landing_texts-body" v-html="blurbs[0].content"></p>
          <p class="landing_texts-body" v-html="blurbs[1].content"></p>
        </div>

        <div v-else>
          <h2 class="landing_texts-title">WHAT IS AVALANCHE APEX CONNECT<sup>™</sup>?</h2>
          <br/>
          <p class="landing_texts-body">
            Avalanche Apex Connect<sup>™</sup> is your portal to in-game rewards and keeps your finger
            on our pulse. Signing up also means you will qualify for playtests and
            closed betas. The fun stuff.
          </p>
          <p class="landing_texts-body">
            With Avalanche Apex Connect<sup>™</sup>, you become part of our special circle of friends.
            Signing up provides in-game rewards, unique game features, and ensures
            you'll never miss an update.
          </p>
        </div>

        <br/>

        <h2 v-if="benefits.length != 0">CURRENT BENEFITS</h2>

        <br/>

        <table class="benefits-table">
          <tr v-for="benefit in benefits" :key="benefit.id">
            <th>{{benefit.header}}</th>
            <td v-html="benefit.content"></td>
          </tr>
        </table>
      </v-col>

      <v-col sm="10" md="5" class="trt-landing-content mt-5 ml-10 d-flex align-center justify-center" v-else>
        <div v-if="tortoiseArticles.length" class="d-flex justify-center flex-column align-start">
          <div v-for="article in tortoiseArticles" :key="article">
            <h2 v-html="article.header"></h2>
            <p v-html="article.content"></p>
          </div>

          <br/>

          <!-- <div class="trt-img-grid align-self-center">
            <div v-for="link in tortoiseArticles[0].links" :key="link">
              <img :src="link" alt="" width="120">
            </div>
          </div> -->

          <div style="width: 100%; display: flex; justify-content: center;">
            <img src="https://acp-portal-assets.avalanchestudios.com/Apex-Angler-Pack-1500x1500.png" alt="" width="100%" class="trt-landing-content-img">
          </div>
        </div>

        <div v-else>
          <h2></h2>
          <p></p>

          <div class="d-flex">
            <div>
              <!-- <img src="link" alt="" width="120"> -->
            </div>
          </div>
        </div>
      </v-col>

      <v-col>
        <LoginComponent initial-mode="register" :policies="policies ? policies : {}"></LoginComponent>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
  .benefits-table th {
   white-space: nowrap;
   padding-right: 10px;
   text-align: left;
   vertical-align:top;
  }

  .landing_texts-title {
    font-size: 36px;
  }

  .landing_texts-body {
    line-height: 1.3;
  }

  .trt-img-grid {
    display: grid; 
    grid-template-columns: 150px 100px 200px;
    grid-template-rows: 1fr 200px;
    gap: 8px; 
    grid-template-areas: 
      "top-1 top-2 top-3"
      "bottom-left bottom-left bottom-right";
  }

  .trt-img-grid div:nth-child(4) { grid-area: bottom-left; }
  .trt-img-grid div:nth-child(5) { grid-area: bottom-right; }
  .trt-img-grid div:nth-child(1) { grid-area: top-1; }
  .trt-img-grid div:nth-child(2) { grid-area: top-2; }
  .trt-img-grid div:nth-child(3) { grid-area: top-3; }

  .trt-img-grid div {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.3);
  }

  .trt-img-grid div img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  .trt-landing-content { color: white; }

  .trt-landing-content-img { width: 300px; }

  @media (max-width: 1024px ) {
    .trt-landing-content { 
      min-width: 100%; 
      margin: 0 !important;
    }

    .trt-landing-content-img { width: 100%; }
  }

</style>

<script>
import LoginComponent from "@/components/Login.vue";
import store from "../store";
import { mapState } from "vuex";
import { policies } from "../store/modules/policies";

if (!store.state.policies) store.registerModule("policies", policies);

export default {
  name: "Register",
  components: {
    LoginComponent,
  },
  computed: {
    ...mapState("news", {
          blurbs: (state) => state.blurbs,
          benefits: (state) => state.benefits,
          tortoiseArticles: (state) => state.tortoiseArticles
      }),
    ...mapState("policies", {
      policies: (state) => state.policies,
    }),
    acpConfig: () => {
      return window.ACP_CONFIG;
    },
    divisionTheme: () => sessionStorage.getItem('themeName'),
  },
  created() {
    this.fetchPolicies();
  },
  methods: {    
    fetchPolicies() {
      this.$store.dispatch("policies/getPolicies");
    },
  }
};
</script>